export default function Login() {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center p-6 bg-gradient-to-b from-dcvfd-dark via-dcvfd to-dcvfd-light text-white">
      <div className="w-full max-w-sm rounded-2xl bg-white/10 backdrop-blur p-8 flex flex-col items-center shadow-2xl ring-1 ring-white/15">
        <div className="h-16 w-16 mb-5 rounded-full bg-white/15 flex items-center justify-center text-3xl">🚒</div>
        <h1 className="text-2xl font-bold tracking-tight mb-0.5">DCVFD Membership</h1>
        <p className="text-white/70 text-sm mb-8 text-center">Dale City Volunteer Fire Department</p>

        <a
          href="/api/auth/entra/login"
          className="group flex w-full items-center justify-center gap-3 rounded-xl bg-white px-6 py-3.5 text-base font-semibold text-dcvfd-dark shadow-lg hover:bg-zinc-100 active:scale-[0.98] min-h-[52px] transition-all"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" className="shrink-0">
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
          <span>Sign in with Microsoft</span>
        </a>
      </div>
      <p className="mt-6 text-xs text-white/50 text-center">&copy; 2026 Dale City Volunteer Fire Department, Inc.</p>
    </div>
  );
}
